/**
 * Caption typography components
 *
 * @example
 * ```tsx
 * <CaptionS>Uppercase caption</CaptionS>
 * <CaptionXS isUpperCase={false}>Lowercase caption</CaptionXS>
 * ```
 */

import { TYPOGRAPHY_VARIANTS } from './config';
import { createTypographyComponent } from './Factory';

/**
 * CaptionS - Small caption (12px, uppercase by default)
 */
export const CaptionS = createTypographyComponent(
	'CaptionS',
	TYPOGRAPHY_VARIANTS.CaptionS,
	true
);

/**
 * CaptionXS - Extra small caption (10px, uppercase by default)
 */
export const CaptionXS = createTypographyComponent(
	'CaptionXS',
	TYPOGRAPHY_VARIANTS.CaptionXS,
	true
);
